import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context14; _forEachInstanceProperty(_context14 = ownKeys(Object(source), true)).call(_context14, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context15; _forEachInstanceProperty(_context15 = ownKeys(Object(source))).call(_context15, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _ from 'lodash';
import * as norm from '@rexlabs/entity-normalizer';
import { pushRelateds } from './related';
import { mapDataFromApi, mapDataToApi } from '../../utils/map-data';
import { listLoading, listFetching, listRefreshing, pushListPage, listFailure, pushItem, pushItems, removeItem, itemLoading, itemDeleting, itemUpdating, itemRefreshing, itemFailure, itemsDeleting, itemsUpdating, itemsFailure, removeRelatedItem as reduceRemoveRelatedItem } from '../../reducers/entities';
import invariant from 'invariant';
import uuid from '../../utils/uuid';
export var ACTION_REMOVE_ITEM = 'entities/REMOVE_ITEM';
export var ACTION_UPDATE_ITEM = 'entities/UPDATE_ITEM'; // REFACTOR!

function handleListResponse(_ref) {
  var result = _ref.result,
      config = _ref.config,
      args = _ref.args,
      payload = _ref.payload,
      dispatch = _ref.dispatch;
  var items = result.data;
  var allRelatedData = {};
  var normalized = []; // Similar to `pushItem` we want to extract the related data
  //  here and push it seperately ... so we loop through the list items
  //  and do the same as for `fetchItem`!
  // NOTE: this affects the format that is passed down to the reducer,
  //  having the items in the format { item: data, related: {...} }!!
  //  But relationships are never easy I guess ;)

  _forEachInstanceProperty(items).call(items, function (item) {
    var _norm$processEntityIt = norm.processEntityItem({
      data: item
    }, config.related),
        i = _norm$processEntityIt.item,
        related = _norm$processEntityIt.related,
        relatedData = _norm$processEntityIt.relatedData;

    normalized.push({
      item: i,
      related: related
    });
    allRelatedData = _.merge({}, allRelatedData, relatedData);
  });

  pushRelateds(dispatch, config.related, allRelatedData, payload.uuid);
  return _objectSpread(_objectSpread({}, result), {}, {
    data: normalized,
    args: args
  });
} // TODO: this has limitations with nested relations right now, needs to
//  be resturctured to work better recursively!


function handleItemResponse(_ref2) {
  var result = _ref2.result,
      payload = _ref2.payload,
      dispatch = _ref2.dispatch,
      config = _ref2.config,
      args = _ref2.args;

  var _norm$processEntityIt2 = norm.processEntityItem(result, config.related),
      item = _norm$processEntityIt2.item,
      related = _norm$processEntityIt2.related,
      relatedData = _norm$processEntityIt2.relatedData;

  pushRelateds(dispatch, config.related, relatedData, payload.uuid);
  return {
    data: item,
    related: related,
    args: args
  };
}

function createApiErrorMessage(field, axios) {
  var _context, _context2;

  return _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "You have to define an api function for '".concat(field, "' in your model config, e.g.\n    const config = {\n      entities: {\n        api: {\n          ")).call(_context2, field, ": ")).call(_context, axios, "\n        }\n      }\n    }\n  ");
}
/**
 * Returns action creators that handle all common crud action
 * @param  {string} type
 * @param  {Object} config
 * @return {Object} Object of action creators
 */


export function getCrudActionCreators(type, config) {
  var api = config.api;
  var configArgs = config.args || {};

  var camelType = _.camelCase(type);

  return {
    fetchList: {
      request: function request(payload, actions, dispatch, getState) {
        var _context3;

        // Make sure api action is defined
        invariant(api.fetchList, createApiErrorMessage('fetchList', "axios.get('/list')"));

        var args = _.merge({}, configArgs, payload.args, configArgs.include && _.get(payload, 'args.include') ? {
          include: _concatInstanceProperty(_context3 = "".concat(configArgs.include, ",")).call(_context3, payload.args.include)
        } : {});

        return api.fetchList(type, args, {
          payload: payload,
          actions: actions,
          dispatch: dispatch,
          getState: getState
        }).then(function (result) {
          var _context4;

          return handleListResponse({
            result: _objectSpread(_objectSpread({}, result), {}, {
              data: _mapInstanceProperty(_context4 = result.data).call(_context4, function (data) {
                return mapDataFromApi(data, config);
              })
            }),
            config: config,
            args: args,
            payload: payload,
            dispatch: dispatch
          });
        });
      },
      reduce: {
        initial: listLoading,
        success: pushListPage,
        failure: listFailure
      }
    },
    // NOTE: hacky quick fix! This will refresh the list with the latest arguments!
    // It will go through all loaded pages to return the new list with the same number
    // of items!
    refreshList: {
      request: function request(payload, model, dispatch, getState) {
        var _context5;

        // Collect api calls for all loaded pages and return promise
        var currentState = _.get(getState(), _concatInstanceProperty(_context5 = "entities.".concat(camelType, ".lists.")).call(_context5, payload.id));

        var currentPage = _.get(currentState, 'pagination.currentPage');

        var currentArgs = _.get(currentState, 'args');

        var fetchPages = [];

        for (var loadPage = 1; loadPage <= currentPage; loadPage++) {
          fetchPages.push(model.fetchPage(_objectSpread(_objectSpread({}, payload), {}, {
            args: currentArgs,
            page: loadPage,
            isRefreshing: true
          })));
        }

        return _Promise.all(fetchPages);
      },
      reduce: {
        initial: listRefreshing,
        success: function success(state, action) {
          var _context6;

          var newState = _objectSpread({}, state);

          _forEachInstanceProperty(_context6 = action.payload).call(_context6, function (result, i) {
            var newAction = _objectSpread(_objectSpread({}, action), {}, {
              payload: result
            });

            var page = i + 1;
            newState = pushListPage(newState, newAction, page);
          });

          return newState;
        },
        failure: listFailure
      }
    },
    // Hacky helper to refresh all lists of a given record type, to ensure they're all up to
    // date, e.g. helpful after adding new records through dialogs etc.
    refreshLists: {
      request: function request(payload, model, dispatch, getState) {
        return new _Promise(function (resolve) {
          var listsState = _.get(getState(), "entities.".concat(camelType, ".lists"), {});

          var needRefresh = [];

          for (var listId in listsState) {
            var listState = listsState[listId];
            needRefresh.push(model.refreshList({
              id: listId,
              currentPage: listState.pagination.currentPage,
              args: listState.args
            }));
          }

          if (needRefresh.length) {
            _Promise.all(needRefresh).then(function () {
              resolve(true);
            }).catch(function () {
              // Even on error we don't really want to error out here!
              resolve(false);
            });
          } else {
            // No lists to refresh, so we can resolve directly
            resolve(true);
          }
        });
      },
      reduce: {
        initial: _.identity,
        success: _.identity,
        failure: _.identity
      }
    },
    fetchPage: {
      request: function request(payload, model, dispatch, getState) {
        // Make sure api action is defined
        invariant(api.fetchList, createApiErrorMessage('fetchList', "axios.get('/list')"));

        var args = _.merge({}, configArgs, payload.args, {
          page: payload.page
        });

        return api.fetchList(type, args, {
          payload: payload,
          model: model,
          dispatch: dispatch,
          getState: getState
        }).then(function (result) {
          var _context7;

          return handleListResponse({
            result: _objectSpread(_objectSpread({}, result), {}, {
              data: _mapInstanceProperty(_context7 = result.data).call(_context7, function (item) {
                return mapDataFromApi(item, config);
              })
            }),
            config: config,
            args: args,
            payload: payload,
            dispatch: dispatch
          });
        });
      },
      reduce: {
        initial: listFetching,
        success: pushListPage,
        failure: listFailure
      }
    },
    fetchItem: {
      request: function request(payload, model, dispatch, getState) {
        // Make sure api action and ID are defined
        invariant(api.fetchItem, createApiErrorMessage('fetchItem', "axios.get('/item')"));
        invariant(payload.id, "You need to pass in the ID of the item you want to fetch => 'fetchItem(id: ..., args: {...}})'");

        var args = _.merge({}, configArgs, payload.args);

        return api.fetchItem(type, args, payload.id, {
          payload: payload,
          model: model,
          dispatch: dispatch,
          getState: getState
        }).then(function (result) {
          return handleItemResponse({
            result: mapDataFromApi(result, config),
            payload: payload,
            model: model,
            dispatch: dispatch,
            config: config,
            args: args
          });
        });
      },
      reduce: {
        initial: itemLoading,
        success: pushItem,
        failure: itemFailure
      }
    },
    refreshItem: {
      request: function request(payload, model, dispatch, getState) {
        var _context8;

        // Make sure api action and ID are defined
        invariant(api.fetchItem, createApiErrorMessage('fetchItem', "axios.get('/item')"));
        invariant(payload.id, "You need to pass in the ID of the item you want to fetch => 'fetchItem(id: ..., args: {...}})'");

        var args = _.merge({}, configArgs, _.get(getState(), _concatInstanceProperty(_context8 = "entities.".concat(camelType, ".items.")).call(_context8, payload.id, ".args")), payload.args);

        return api.fetchItem(type, args, payload.id, {
          payload: payload,
          model: model,
          dispatch: dispatch,
          getState: getState
        }).then(function (result) {
          return handleItemResponse({
            result: mapDataFromApi(result, config),
            payload: payload,
            model: model,
            dispatch: dispatch,
            config: config,
            args: args
          });
        });
      },
      reduce: {
        initial: itemRefreshing,
        success: pushItem,
        failure: itemFailure
      }
    },
    createItem: {
      request: function request(payload, model, dispatch, getState) {
        // Make api sure actions and data are defined
        invariant(api.createItem, createApiErrorMessage('createItem', "axios.post('/item')"));
        invariant(payload.data, "You need to define the data object to create an item => 'createItem({data: {...}, args: {...}})'");

        var args = _.merge({}, configArgs, mapDataToApi(payload.data), payload.args);

        return api.createItem(type, args, {
          payload: payload,
          model: model,
          dispatch: dispatch,
          getState: getState
        }).then(function (result) {
          return handleItemResponse({
            result: result,
            payload: payload,
            model: model,
            dispatch: dispatch,
            config: config,
            args: args
          });
        });
      },
      reduce: {
        // TODO: create temporary loading state etc. so components can potentially connect
        //  to it to catch loading|error status
        initial: _.identity,
        success: pushItem,
        // NOTE: we need to catch this on component level, as there is no global
        //  state for the item yet..
        failure: _.identity
      }
    },
    updateItem: {
      request: function request(payload, model, dispatch, getState) {
        // Make sure api action and ID are defined
        invariant(api.updateItem, createApiErrorMessage('updateItem', "axios.put('/item')"));
        invariant(payload.id, "You need to pass in an ID to this API endpoint => 'updateItem({id: ..., data: {...}})'");

        var args = _.merge({}, configArgs, mapDataToApi(payload.data), payload.args);

        return new _Promise(function (resolve, reject) {
          api.updateItem(type, args, payload.id, {
            payload: payload,
            model: model,
            dispatch: dispatch,
            getState: getState
          }).then(function (updateResponse) {
            var listsState = _.get(getState(), "entities.".concat(camelType, ".lists"), {});

            var needRefresh = [];

            for (var listId in listsState) {
              var _context9;

              var listState = listsState[listId];

              if (_includesInstanceProperty(_context9 = listState.items).call(_context9, payload.id)) {
                needRefresh.push(model.refreshList({
                  id: listId,
                  currentPage: listState.pagination.currentPage,
                  args: listState.args
                }));
              }
            }

            dispatch(updateRelatedItem(type, payload.id));

            if (needRefresh.length) {
              _Promise.all(needRefresh).then(function () {
                resolve(updateResponse);
              }).catch(function () {
                // Even on error we don't really want to error out here!
                resolve(updateResponse);
              });
            } else {
              // No lists to refresh, so we can resolve directly
              resolve(updateResponse);
            }
          }).catch(reject);
        });
      },
      reduce: {
        initial: itemUpdating,
        success: pushItem,
        failure: itemFailure
      }
    },
    trashItem: {
      request: function request(payload, model, dispatch, getState) {
        // Make sure api action and ID are defined
        invariant(api.trashItem, createApiErrorMessage('trashItem', "axios.delete('/item')"));
        invariant(payload.id, "You need to pass in an ID to this API endpoint => 'trashItem({id: ..., args: {...}})'");

        var args = _.merge(configArgs, payload.args);

        return new _Promise(function (resolve, reject) {
          api.trashItem(type, args, payload.id, {
            payload: payload,
            model: model,
            dispatch: dispatch,
            getState: getState
          }).then(function (response) {
            dispatch(removeRelatedItem(type, payload.id));
            resolve(response);
          }).catch(function (e) {
            console.error(e);
            reject(e);
          });
        });
      },
      reduce: {
        initial: itemDeleting,
        success: removeItem,
        failure: itemFailure
      }
    },
    // NOTE: we do not have an API example for soft- and hard deletion atm,
    //  so I don't how this would look like
    // deleteItem: {},
    removeRelatedItem: {
      actionName: ACTION_REMOVE_ITEM,
      reduce: function reduce(state, action) {
        var _context10, _context11, _context12, _context13;

        var related = _.get(config, 'related', {});

        var configRelated = _mapInstanceProperty(_context10 = _mapInstanceProperty(_context11 = _filterInstanceProperty(_context12 = _mapInstanceProperty(_context13 = _Object$keys(related)).call(_context13, function (name) {
          return related[name] ? related[name].model : null;
        })).call(_context12, Boolean)).call(_context11, function (r) {
          return _.isArray(r) ? r[0] : r;
        })).call(_context10, function (r) {
          return r.modelName;
        });

        if (_includesInstanceProperty(configRelated).call(configRelated, action.payload.type)) {
          return reduceRemoveRelatedItem(state, action);
        }

        return state;
      }
    },
    updateRelatedItem: {
      actionName: ACTION_UPDATE_ITEM,
      // TODO: go through relations and reload if updated item
      //  was one of them
      reduce: _.identity
    },
    bulkUpdateItems: {
      request: function request(payload) {
        // Make api sure action is defined
        invariant(api.bulkUpdateItems, createApiErrorMessage('bulkUpdateItems', "axios.put('/items')"));
        return api.bulkUpdateItems(type, _.merge(configArgs, payload.args), mapDataToApi(payload.data));
      },
      reduce: {
        initial: itemsUpdating,
        success: pushItems,
        failure: itemsFailure
      }
    },
    bulkTrashItems: {
      request: function request(payload) {
        // Make api sure action is defined
        invariant(api.bulkTrashItems, createApiErrorMessage('bulkTrashItems', "axios.delete('/items')"));
        return api.bulkTrashItems(type, _.merge(configArgs, payload.args), payload.data);
      },
      reduce: {
        initial: itemsDeleting,
        success: pushItems,
        failure: itemsFailure
      }
    }
  };
} // The following are global actions, that all models can listen to
//  in order to remove items from the lists or refresh lists where
//  the related item is in..

function removeRelatedItem(type, id) {
  return {
    type: ACTION_REMOVE_ITEM,
    payload: {
      type: type,
      id: id
    }
  };
}

function updateRelatedItem(type, id) {
  return {
    type: ACTION_UPDATE_ITEM,
    payload: {
      type: type,
      id: id
    }
  };
}
/**
 * Touch entity etag to force component updates
 * Etags are used to determine if HoCs (withEntity/List) should update!
 * @param  {Object} state
 * @return {Object}
 */


export function touchEtag(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    etag: uuid()
  });
}